<template>
    <template v-if="hasMultipleClinicalProducts">
        <span :class="getProductPillClass(productId)" class="pill">
            {{ getProductFullName(productId) }}
        </span>
    </template>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import { Container } from "aurelia-dependency-injection";

import { AgencyService } from "../../../services/agency.service";
import { ProductService } from "../../../services/product.service";
import { ApplicationEnum } from "../../../enums/enums";
import { getProductPillClass, getProductFullName } from "../../../common/vue-helpers/modifiers/application-modifiers";

export default defineComponent({
    props: {
        productId: {
            typeof: ApplicationEnum,
            default: null
        }
    },

    data() {
        return {
            _agencyService: null,
            _productService: null,
            id: null,
            getProductPillClass,
            getProductFullName
        };
    },

    created() {
        this._agencyService = Container.instance.get(AgencyService);
        this._productService = Container.instance.get(ProductService);
    },

    computed: {
        hasMultipleClinicalProducts() {
            return this._agencyService?.getHasMultipleClinicalProds();
        }
    }
});
</script>
